import React, { useRef } from "react";
import LozengeButton from "./LozengeButton";
import ChevronDownBlackIcon from "../assets/chevron-down-black.svg";
import ChevronDownWhiteIcon from "../assets/chevron-down-white.svg";
import Box from "./Box";

function SelectStandard({
  name,
  value,
  options,
  handleChange,
  borderWidth,
  invertOnMobile = true,
}) {
  const selectRef = useRef();

  const handleButtonClick = () => {
    if (selectRef.current) {
      selectRef.current.click();
    }
  };

  return (
    <Box position="relative">
      <LozengeButton
        borderWidth={borderWidth}
        small
        onClick={handleButtonClick}
        width="210px"
        invertOnMobile={invertOnMobile}
      >
        <Box display="flex" justifyContent="space-between" width="100%">
          {value || name}
          <Box
            display={[
              invertOnMobile ? "none" : "initial",
              "initial",
              null,
              null,
            ]}
          >
            <ChevronDownBlackIcon />
          </Box>

          <Box
            display={[invertOnMobile ? "initial" : "none", "none", null, null]}
          >
            <ChevronDownWhiteIcon />
          </Box>
        </Box>
      </LozengeButton>
      <select
        style={{
          opacity: 0,
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
        value={value}
        onChange={(event) => handleChange(event.target.value)}
      >
        <option></option>
        {options.map((option) => (
          <option key={option} value={option[0]}>
            {option[1]}
          </option>
        ))}
      </select>
    </Box>
  );
}

export default SelectStandard;
